// extracted by mini-css-extract-plugin
export default {"angleOfRotationGroup":"styles_angleOfRotationGroup__jaBHT","select":"styles_select__aAWhe","rotation":"styles_rotation__8nk2g"};